import { gql } from '@apollo/client';

export * from './assetReportGroups.query.generated';

export const ASSET_REPORT_GROUPS = gql`
  query assetReportGroups(
    $softwareEscrowId: ID!
    $assetId: ID
    $page: Int
    $perPage: Int
    $order: QueryOrderEnum
    $orderBy: AssetsOrderByEnum
    $period: ISO8601Date
  ) {
    assetReportGroups(
      softwareEscrowId: $softwareEscrowId
      assetId: $assetId
      page: $page
      perPage: $perPage
      order: $order
      orderBy: $orderBy
      period: $period
    ) {
      nodesCount
      pagesCount
      hasPreviousPage
      hasNextPage
      nodes {
        id
        lastGenerated
        asset {
          id
          depositSource
        }
        assetReports {
          id
          asset {
            id
            depositSource
          }
          createdAt
          period
        }
      }
    }
  }
`;
